export const header = {
    home:'Home',
    product:'Product',
    case:'Case',
    about:'About',
    system:'System',
}
export const footer = {
    companyName:'Nanjing Tiechen Safety Technology Co., Ltd',
    mobilePhone:'mobilePhone：17384461558（Manager Leng）',
    telephone:'Tel：025-52211001',
    email:'Email：lengyanfei@techin-aiot.com',
    address:'Address：Room 303, Block B, Jimeisi Building, Tulip Road, Yuhuatai District, Nanjing',
    miniPro:'follow Mini Program',
    app:'download APP'
}
// 首页
export const home = {
    welcome:'Welcome to Tiechen technology',
    bannerWords:'On the basis of fire engineering, maintenance and intelligent business, we mainly focus on it, Internet of things, big data and AI, expand the field of intelligent fire protection and security, and independently develop a number of products such as intelligent fire protection, intelligent security, intelligent power consumption, intelligent smoke sensing, video RTC and AI video recognition, which are widely used in many units and have won many awards such as scientific and technological progress of Railway Bureau.',
    aboutBtn:'about us',
    contactBtn:'contact us'
}
